import * as React from 'react';
import { useGeolocated } from "react-geolocated";




export function useGetLocationCoords():any {
    const { coords, isGeolocationAvailable, isGeolocationEnabled } =
        useGeolocated({
            positionOptions: {
                enableHighAccuracy: false,
            },
            userDecisionTimeout: 5000,
        });
    function getLoc(): { loc: GeolocationCoordinates, isAvailable: boolean, isEnabled: boolean } {
        return { loc: coords, isAvailable: isGeolocationAvailable, isEnabled: isGeolocationEnabled };
    }
    return getLoc;



}

export default useGeolocated;
